import { Helpers } from '../../helpers';
import { IFieldDevelopmentTeam } from '../../interfaces/ifield-development-team';
import { Area } from '../area';
import { Well } from '../well';

export class FieldDevelopmentTeamBase {
  FieldDevelopmentTeamId: number;
  Description: string;
  SortOrder: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Areas_FieldDevelopmentTeam?: Array<Area> | null;
  Wells_FieldDevelopmentTeam?: Array<Well> | null;

  constructor(item?: IFieldDevelopmentTeam) {
    if (item) {

      this.FieldDevelopmentTeamId = item.FieldDevelopmentTeamId;
      this.Description = item.Description;
      this.SortOrder = item.SortOrder;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Areas_FieldDevelopmentTeam = Helpers.createClassArray(Area, item.Areas_FieldDevelopmentTeam);
      this.Wells_FieldDevelopmentTeam = Helpers.createClassArray(Well, item.Wells_FieldDevelopmentTeam);
    }
  }
}